var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('div',{staticClass:"table-data-header increased-spacing"},[_vm._v(_vm._s(_vm.dataHeader))]),_vm._v(" "),_c('ul',_vm._l((_vm.data),function(item,index){return _c('li',{key:index,class:_vm.listType},[_vm._v("\n            "+_vm._s(item)+"\n        ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }